import axios from 'axios';
import axiosInstance from '../axiosConfig/instance';
import Swal from 'sweetalert2';


export async function logoutfun() {
   try {
      const response = await axiosInstance.get('/v1/owners/auth/logout');
      console.log(response)
      localStorage.removeItem('token');
      localStorage.removeItem('refreshtoken');

      return response
   } catch (error) {
      console.log(error);

   }
}
export async function updateprofile(formdata) {
   try {
      const response = await axiosInstance.post(`/v1/owners/auth/update-owner-profile`, formdata, // FormData as the request body
         {
            headers: {
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         } // FormData as the request body
      );
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);
      return error;

   }
}
export async function forgetpassword(phone) {
   try {
      const response = await axiosInstance.post(`/v1/owners/auth/forget-password`, { "phone_number": phone });
      localStorage.setItem("token", response.data.data.Token)


      return response.data
   } catch (error) {
      console.log(error);
      return error

   }
}
export async function verifyotp(otp) {
   try {
      // تحويل OTP إلى رقم
      const numericOtp = Number(otp);

      if (isNaN(numericOtp)) {
         throw new Error("OTP must be a valid number");
      }

      // جلب الـ Token من localStorage
      const token = localStorage.getItem("regtoken");

      // التحقق من وجود التوكن
      if (!token) {
         throw new Error("Token is not available in localStorage");
      }

      // إرسال الطلب مع الهيدر
      const response = await axiosInstance.post(
         `/v1/owners/auth/otp/verify`,
         { "otp": `${otp}` },
         {
            headers: {
               Authorization: `Bearer ${token}`, // إضافة الـ Token كـ Bearer Token
            },
         }
      );

      // حفظ التوكن الجديد إذا تم إرجاعه
      // localStorage.setItem("token", response.data.data.Token);

      return response.data;
   } catch (error) {
      console.log(error);
      return error;
   }
}


export async function resetpassword(data) {
   try {
      const response = await axiosInstance.post(`/v1/owners/auth/reset-password`, data);
      console.log(response)


      return response.data
   } catch (error) {
      console.log(error);

      return error
   }
}

export async function create(data) {
   try {
      const response = await axiosInstance.post(`/v1/owners/auth/register`, data, // FormData as the request body
         {
            headers: {
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         });
      console.log(response)


      return response
   } catch (error) {
      console.log(error);

      return error
   }
}
export async function profile() {
   try {
      const response = await axiosInstance.get('/v1/owners/auth/profile');
      console.log(response)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function refreshtoken() {
   try {
      const refreshToken = localStorage.getItem('refreshtoken');
      if (!refreshToken) {
         throw new Error('No refresh token found.');
      }

      const response = await axiosInstance.get('/v1/owners/auth/refresh', null, {
         headers: {
            'Authorization': `Bearer ${refreshToken}`
         }
      });

      if (response.data?.data?.token) {
         const newToken = response.data.data.token;
         localStorage.setItem('token', newToken);
         axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      } else {
         throw new Error('No token received in response');
      }

      return response;
   } catch (error) {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshtoken');
      throw error;
   }
}


export async function changepasswordfun(changepassword) {
   try {
      const response = await axiosInstance.post('/v1/owners/auth/owner-change-password', changepassword);
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error.response.data);
      return error.response.data

   }
}




export async function users() {
   try {
      const response = await axiosInstance.get('/v1/users/clients');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}
export async function user(id) {
   try {
      const response = await axiosInstance.get(`/v1/users/clients/${id}`);
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);
   }
}




export async function owners() {
   try {
      const response = await axiosInstance.get('/v1/users/owners');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}



export async function unit(id) {
   console.log(id)
   try {
      const response = await axiosInstance.get(`/v1/owners/units/${id}`,{
                  headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}` 
         }
      });
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);
   }
}

////////////////////////////////////Units////////////////////////////////
export async function units() {
   try {
      const response = await axiosInstance.get('/v1/owners/units');
      console.log(response.data)

      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function delunit(id) {
   try {
      const response = await axiosInstance.post(`/v1/owners/units/${id}`);
      console.log(response.data)

      return response.data.data
   } catch (error) {
      console.log(error);


   }
}
export async function updateunit(formdata, id) {
   try {
      const response = await axios.post(
         `https://app.baskeg.com/api/v1/owners/update-unit/${id}`,
         formdata, {
         headers: {
            "Accept": "application/json",
            "api-key": "2yOyqnvKCsCmsTlODYtzjqy1fFgzqGcTyu8srWPaOaHFOChy18xd7hc3tjY0AofH",
            "Accept-Language": "en",
            'Authorization': `Bearer ${localStorage.getItem('token')}`
         },
      }
      );


      return response.data;
   } catch (error) {
      console.error("Error creating contract:", error.response?.data || error.message);
      return error; // Re-throw the error for further handling if needed
   }
}
export async function createunit(formdata) {
   console.log(formdata)
   try {
      const response = await axios.post(
         `https://app.baskeg.com/api/v1/owners/units`,
         formdata, {
         headers: {
            "Accept": "application/json",
            "api-key": "2yOyqnvKCsCmsTlODYtzjqy1fFgzqGcTyu8srWPaOaHFOChy18xd7hc3tjY0AofH",
            "Accept-Language": "en",
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            //  'Content-Type': "application/json", // Set the appropriate header
             'cache-control':"no-cache, private",
             'Content-Type': 'multipart/form-data', // Set the appropriate header

         },
      }
      );


      return response.data;
   } catch (error) {
      // console.error("Error creating contract:", error.response?.data || error.message);
      // return error; // Re-throw the error for further handling if needed
      // Log the detailed error response
      // console.error("Error Response:", error.response?.data);
      // console.error("Status:", error.response?.status);
      // console.error("Headers:", error.response?.headers);
          // Safely extract error message
    const errorMessage = error.response?.data?.message || "Unknown Error";

    return {
      success: false,
      message: errorMessage,
      status: error.response?.status,
    };
  
   }
}
export async function unitsPending() {
   try {
      const response = await axiosInstance.get('/v1/owners/pending-units');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function unitsApproved() {
   try {
      const response = await axiosInstance.get('/v1/owners/approved-units');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function unitsRejected() {
   try {
      const response = await axiosInstance.get('/v1/owners/rejected-units');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function unitsArrivingsoon() {
   try {
      const response = await axiosInstance.get('/v1/users/arriving-soon-units');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function unitsCurrentlyhosting() {
   try {
      const response = await axiosInstance.get('/v1/users/checking-out-units');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function unitsCheckingout() {
   try {
      const response = await axiosInstance.get('/v1/users/units');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}
export async function ownerdetail(id) {
   try {
      const response = await axiosInstance.get(`v1/users/owners/${id}`);
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function deleteunit(id) {
   try {
      const response = await axiosInstance.post(`/v1/users/units/${id}`);
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);


   }
}
////////////////////////////////Booking //////////////////////////////////////////
export async function booking() {
   try {
      const response = await axiosInstance.get('/v1/users/bookings');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function bookingPending() {
   try {
      const response = await axiosInstance.get('/v1/users/pending-bookings');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function bookingApproved() {
   try {
      const response = await axiosInstance.get('/v1/users/approved-bookings');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function bookingRejected() {
   try {
      const response = await axiosInstance.get('/v1/users/rejected-bookings');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}
export async function deletebooking(id) {
   try {
      const response = await axiosInstance.post(`/v1/users/bookings/${id}`);
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);


   }
}


export async function updateBooking(id) {
   try {
      const response = await axiosInstance.post(`/v1/users/bookings/${id}`);
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);


   }
}
////////////////////////////////////////contracts////////////////////////////////
export async function contract() {
   try {
      const response = await axiosInstance.get('/v1/owners/contracts');
      console.log(response.data)

      Swal.fire("Contract Created");
      return response.data.data
   } catch (error) {
      console.log(error);


   }
}
export async function updatecontract(formdata, id) {
   try {
      const response = await axiosInstance.post(`/v1/owners/update-contracts/${id}`, formdata, // FormData as the request body
         {
            headers: {
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         });
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);
      return error;

   }
}





export async function deletecontract(id) {
   try {
      const response = await axiosInstance.post(`/v1/users/contracts/${id}`);
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);


   }
}
//////////////////////////////////Service Request Methods////////////////////////////////

export async function servicereq() {
   try {
      const response = await axiosInstance.get('/v1/users/service-requests');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function delservicereq(id) {
   try {
      const response = await axiosInstance.post(`/v1/users/service-requests/${id}`);
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

////////////////////////////analysis/////////////////////////////////////////////

export async function analysistab() {
   try {
      const response = await axiosInstance.get('/v1/users/units-analysis-tab');
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);
   }
}
export async function getanalysis() {
   try {
      const response = await axiosInstance.get('https://app.baskeg.com/api/v1/owners/units-analysis',);
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);

      return error
   }
}

////////////////////////////Helpers////////////////////////////////
export async function featuress() {
   try {
      const response = await axiosInstance.get('/v1/features');
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);
   }
}

export async function unittypess() {
   try {
      const response = await axiosInstance.get('/v1/unit-types');
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function compound() {
   try {
      const response = await axiosInstance.get('/v1/compounds');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}
export async function placetype() {
   try {
      const response = await axiosInstance.get('/v1/place-types');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}

export async function broker() {
   try {
      const response = await axiosInstance.get('/v1/users/brokers');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function addbrokers(formdata) {
   try {
      const response = await axiosInstance.post('/v1/users/brokers', formdata, // FormData as the request body
         {
            headers: {
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         });
      console.log(response.data)
      Swal.fire("Broker Created");
      return response
   } catch (error) {
      console.log(error);
      // if(error.message === "Request failed with status code 500"){
      //    Swal.fire("Broker already exists");
      // }

      return error
   }
}
export async function delbroker(id) {
   try {
      const response = await axiosInstance.post(`/v1/users/brokers/${id}`);
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);


   }
}


export async function editbrokerr(id, formData) {
   try {
      const response = await axiosInstance.post(`/v1/users/update-brokers/${id}`, formData, // FormData as the request body
         {
            headers: {
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         });
      console.log(response.data)
      Swal.fire("Broker Edited");


      return response.data
   } catch (error) {
      console.log(error);


   }
}
/////////////////////////////Cancelation///////////////////////

export async function updateCancelationReq(id, formdata) {
   console.log(id)
   try {
      const response = await axiosInstance.post(`/v1/users/update-unit/${id}`, formdata, // FormData as the request body
         {
            headers: {
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         });
      console.log(response.data)
      return response
   } catch (error) {
      console.log(error);


   }
}


////////////////////Helpers////////////////////
export async function countries() {
   try {
      const response = await axiosInstance.get('/v1/countries');
      console.log(response)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function cities() {
   try {
      const response = await axiosInstance.get('/v1/cities');
      console.log(response)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function identitytypes() {
   try {
      const response = await axiosInstance.get('/v1/identity-types');
      console.log(response)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


/////////////////////////maintainers////////////////////
export async function fetchservices() {
   try {
      const response = await axiosInstance.get('/v1/services');
      console.log(response.data)


      return response.data.data
   } catch (error) {
      console.log(error);


   }
}


export async function fetchmaintainers() {
   try {
      const response = await axiosInstance.get('/v1/owners/maintenance');
      console.log(response.data)


      return response.data
   } catch (error) {
      console.log(error);
      return error

   }
}

// Payment
export async function Ownerpayment() {
   try {
      const response = await axiosInstance.get('https://app.baskeg.com/api/v1/owners/payments',{
         'Authorization': `Bearer ${localStorage.getItem('token')}`,
      });
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);

      return error
   }
}
//Bank Account
export async function bankaccount() {
   try {
      const response = await axiosInstance.get('https://app.baskeg.com/api/v1/owners/my-bank-accounts',{
         'Authorization': `Bearer ${localStorage.getItem('token')}`,
      });
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);

      return error
   }
}
//Edit Bank Account
export async function editbankaccount(id, formdata) {
   try {
      const response = await axiosInstance.post(`/v1/owners/update-bank-accounts/${id}`, formdata, // FormData as the request body
         {
            headers: {
               'Authorization': `Bearer ${localStorage.getItem('token')}`,
               'Content-Type': 'multipart/form-data', // Set the appropriate header
            },
         });
      console.log(response.data)
      return response.data.data
   } catch (error) {
      console.log(error);

      return error
   }
}
//Delete Account
export async function deleteAccount(id) {
   try {
      const response = await axiosInstance.post(`/v1/owners/bank-accounts/${id}`,
         {
            headers: {
               Authorization: `Bearer ${localStorage.getItem('token')}`,
               "Content-Type": "application/json",
             },
         });
      console.log(response.data)
      return response.data
   } catch (error) {
      console.log(error);
   }
}

//Reservation
export async function reservation() {
   try {
      const response = await axiosInstance.get(`/v1/owners/reservations-analysis`);
      console.log(response.data)

      return response.data.data
   } catch (error) {
      console.log(error);

      return error
   }
}
//Chat
export async function chats() {
   try {
      const response = await axiosInstance.get(`/v1/owners/owner-chats`);
      console.log(response.data)

      return response.data.chats
   } catch (error) {
      console.log(error);

      return error
   }
}
//Chat Messages

export async function chatmessages(id) {
   try {
      const response = await axiosInstance.get(`/v1/owners/get-owner-messages/${id}`);
      console.log(response.data, "messages",id)

      return response.data.messages
   } catch (error) {
      console.log(error);

      return error
   }
}

//Notification Global
export async function globalNotification() {
   try {
      const response = await axiosInstance.get(`/v1/owners/notifications`);
      console.log(response.data, "messages")

      return response.data
   } catch (error) {
      console.log(error);

      return error
   }
}
export async function ownerNotification() {
   try {
      const response = await axiosInstance.get(`/v1/owners/owners/notifications`);
      console.log(response.data, "messages")

      return response.data
   } catch (error) {
      console.log(error);

      return error
   }
}
